export enum AddIncidentOptions {
  Url = 'Url',
  Manual = 'Manual',
}

export const AddIncidentOptionsDescriptor = Object.freeze({
  [AddIncidentOptions.Url]: { title: 'Add via URL', description: '(overnight processing)' },
  [AddIncidentOptions.Manual]: { title: 'Enter manually', description: null },
});
